module.exports = (texts) => {
  return {
    "personal": [
      {
        "type": "text",
        "name": "name",
        "placeholder": texts["HCP_PROFILE_PAGE_NAME"],
        "label": texts["HCP_PROFILE_PAGE_NAME"],
        "required": true
      },
      {
        "type": "text",
        "name": "surname",
        "placeholder": texts["HCP_PROFILE_PAGE_SURNAME"],
        "label": texts["HCP_PROFILE_PAGE_SURNAME"],
        "required": true
      },
      {
        "type": "text",
        "name": "telephone",
        "placeholder": texts["HCP_PROFILE_PAGE_TELEPHONE"],
        "label": texts["HCP_PROFILE_PAGE_TELEPHONE"],
        "required": true
      },
      {
        "type": "text",
        "name": "mobile",
        "placeholder": texts["HCP_PROFILE_PAGE_MOBILE"],
        "label": texts["HCP_PROFILE_PAGE_MOBILE"],
        "required": true
      },
      {
        "type": "text",
        "name": "linkedinProfile",
        "placeholder": texts["HCP_PROFILE_PAGE_LINKEDIN"],
        "label": texts["HCP_PROFILE_PAGE_LINKEDIN"]
      }
    ],
    "password": [
      {
        "type": "password",
        "name": "oldPassword",
        "placeholder": texts["HCP_PROFILE_PAGE_PASSWORD_CURRENT"],
        "label": texts["HCP_PROFILE_PAGE_PASSWORD_CURRENT"],
        "required": true
      },
      {
        "type": "password",
        "name": "newPassword",
        "placeholder": texts["HCP_PROFILE_PAGE_PASSWORD_NEW"],
        "label": texts["HCP_PROFILE_PAGE_PASSWORD_NEW"],
        "required": true
      },
      {
        "type": "password",
        "name": "confirmNewPassword",
        "placeholder": texts["HCP_PROFILE_PAGE_PASSWORD_CONFIRM"],
        "label": texts["HCP_PROFILE_PAGE_PASSWORD_CONFIRM"],
        "required": true
      }
    ]
  }
} 